import React from "react";

import { Box } from "@atsent/components";

import { Skeleton } from "components/atom/Skeleton";

import "./DashboardItem.scss";

export type DashboardItemProps = {
  cx?: string;
  title: string;
  list?: { text: string; value: number }[] | null;
};

export const DashboardItem: React.FC<DashboardItemProps> = ({
  cx = "",
  title,
  list,
}) => {
  return (
    <Box cx={`DashboardItem ${cx}`}>
      <div className="summary space-between">
        <span className={"left"}>{title}</span>
        {!!list ? (
          <span className={"right"}>
            {list.reduce((a, c) => a + c.value, 0).toLocaleString()}
          </span>
        ) : (
          <Skeleton />
        )}
      </div>
      <ul>
        {!!list ? (
          list
            .sort((a, b) => b.value - a.value)
            .filter((i, idx) => idx < 3)
            .map(({ text, value }) => (
              <li className={"space-between"} key={`${title}-${text}-${value}`}>
                <span className={"left"}>{text.replaceAll(/[-_]/g, " ")}</span>
                <span className={"right"}>{value.toLocaleString()}</span>
              </li>
            ))
        ) : (
          <>
            <li>
              <Skeleton />
            </li>
            <li>
              <Skeleton />
            </li>
            <li>
              <Skeleton />
            </li>
          </>
        )}
      </ul>
    </Box>
  );
};
